import { render } from "./LabelDisclaimer.vue?vue&type=template&id=1fcfb830&scoped=true"
import script from "./LabelDisclaimer.vue?vue&type=script&lang=js"
export * from "./LabelDisclaimer.vue?vue&type=script&lang=js"

import "./LabelDisclaimer.vue?vue&type=style&index=0&id=1fcfb830&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcfb830"]])

export default __exports__